import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { ArrowRight, Copy } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import type { ProccesedWallets } from '@/modules/networks/hooks/use-wallets-card';
import { useWalletsList } from '@/modules/networks/hooks/use-wallets-list';
import { CopyButton, CopyTooltip, CopyTrigger } from '@/modules/shared/components/copy-button/copy-button';
export interface WalletsListProps {
  wallets: ProccesedWallets[];
  className?: string;
}
function WalletsList(t0) {
  const $ = _c(10);
  const {
    wallets,
    className
  } = t0;
  const {
    handleItemClick
  } = useWalletsList();
  let t1;
  if ($[0] !== className) {
    t1 = cn("space-y-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleItemClick || $[3] !== wallets) {
    let t3;
    if ($[5] !== handleItemClick) {
      t3 = wallet => <div key={wallet.id} className="flex cursor-pointer flex-col gap-2 rounded-xl p-2 shadow-xs" onClick={event => {
        handleItemClick(event, wallet.address);
      }}><div className="flex justify-between"><div className="flex flex-col"><span className="text-sm/5.5 font-semibold">{wallet.name}</span><div className="flex items-center justify-between"><div className="flex items-center gap-2"><div className="flex items-center gap-1"><div className="relative size-6 overflow-hidden rounded-full"><Image src={wallet.image} alt={wallet.name} fill={true} priority={true} className="absolute" /></div><Link href="/network/powerhouse#wallets" target="_blank" className="text-status-progress font-normal">{wallet.shortAddress}</Link></div><CopyButton value={wallet.address}><CopyTooltip side="bottom" tooltip="Copy Address" copiedTooltip="Copied!"><CopyTrigger variant="icon" size="iconXsm"><Copy /></CopyTrigger></CopyTooltip></CopyButton></div></div></div><Button variant="outline" size="icon" asChild={true} aria-label="View wallet details"><Link href="/network/powerhouse#wallets" target="_blank"><ArrowRight className="size-4" /></Link></Button></div><div className="flex justify-between px-2 py-1"><span className="text-foreground/50 text-sm/5.5 font-semibold">Balance (USDS)</span><span className="text-foreground text-sm/5.5 font-semibold">{wallet.usdsBalance.toLocaleString()}</span></div><div className="flex justify-between px-2 py-1"><span className="text-foreground/50 text-sm/5.5 font-semibold">Balance (SKY)</span><span className="text-foreground text-sm/5.5 font-semibold">{wallet.skyBalance.toLocaleString()}</span></div></div>;
      $[5] = handleItemClick;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = wallets.map(t3);
    $[2] = handleItemClick;
    $[3] = wallets;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export { WalletsList };